import { roundingRuleActionTypes } from './../constants/ApiConstants';

const initialState = {
  master_data: [],
  loading: false,
  saving: false,
  get_rounding_rule: [],
  get_rounding_rule_details: null,
  rounding_rule_added: false,
  rounding_rule_deleted: false,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case roundingRuleActionTypes.get_masterdata.REQUEST:
  case roundingRuleActionTypes.get_rounding_rule.REQUEST:
    return {
      loading: true,
      saving: true,
      rounding_rule_added: false,
    };
  case roundingRuleActionTypes.post_rounding_rule.REQUEST:
    return {
      ...state,
      saving: true,
      loading: false,
      rounding_rule_added: false,
    };
  case roundingRuleActionTypes.delete_rounding_rule.REQUEST:
    return {
      ...state,
      loading: true,
      rounding_rule_deleted: false,
    };
  case roundingRuleActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      saving: false,
      master_data: payload,
    };
  case roundingRuleActionTypes.get_rounding_rule.SUCCESS:
    return {
      ...state,
      loading: false,
      saving: false,
      get_rounding_rule: payload,
    };
  case roundingRuleActionTypes.get_rounding_rule_byId.REQUEST:
    return {
      ...state,
      loading: true,
      get_rounding_rule_details: null,
    };
  case roundingRuleActionTypes.get_rounding_rule_byId.SUCCESS:
    return {
      ...state,
      loading: false,
      get_rounding_rule_details: payload,
    };
  case roundingRuleActionTypes.post_rounding_rule.SUCCESS:
    return {
      ...state,
      // loading: false,
      saving: false,
      rounding_rule_added: true,
    };
  case roundingRuleActionTypes.delete_rounding_rule.SUCCESS:
    return {
      ...state,
      loading: false,
      rounding_rule_deleted: true,
    };
  case roundingRuleActionTypes.get_rounding_rule.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case roundingRuleActionTypes.update_from_index.SUCCESS:
    return {
      ...state,
      update_from_index: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/rounding-rule/reducers/RoundingRuleReducers.js